<template>
  <div>
    <v-card>
      <v-card-title>
        <h1>{{ title }}</h1>

        <v-spacer></v-spacer>

        <v-text-field
          class="search-bar"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          dense
        ></v-text-field>
      </v-card-title>

      <v-divider></v-divider>

      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="10"
        :search="search"
        :loading="loading"
      >
        <template v-slot:item.action="{ item }" v-if="routeName">
          <v-btn @click="viewItem(item)" text
            ><v-icon left>mdi-eye</v-icon> View</v-btn
          >
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'

export default {
  name: 'BaseReadonlyTable',
  props: {
    title: String,
    routeName: String,
    getUrl: String,
    headers: Array,
    url: String,
    item: Object,
    itemId: String,
    getId: String
  },
  data() {
    return {
      search: '',
      items: [],
      loading: false
    }
  },
  computed: {
    fullUrl() {
      return this.getUrl ? this.url + this.getUrl : this.url
    }
  },
  created() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      ApiService.get(this.fullUrl, this.getId)
        .then(response => {
          this.items = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    viewItem(item) {
      this.$emit('set-item', item)

      this.$nextTick(() => {
        this.$router.push({
          name: this.routeName,
          params: { id: this.itemId }
        })
      })
    }
  }
}
</script>

<style scoped>
.search-bar {
  max-width: 300px;
  margin-top: 0px;
}
</style>
